import axios from './axiosInstance';

export const commentsList = async (resourceType, id) => {
  const response = await axios.get(`/club_api/${resourceType}/${id}/comments`);
  return response.data;
};

export const newComment = async (resourceType, id, commentData) => {
  const response = await axios.post(`/club_api/${resourceType}/${id}/comments`, commentData);
  return response.data;
};

export const updateComment = async (id, comment) => {
  const response = await axios.put(`/club_api/comments/${id}`, {comment});
  return response.data;
};

export const removeComment = async id => {
  const response = await axios.delete(`/club_api/comments/${id}`);
  return response.data;
};
